import { StyledSubmitButton } from '../../../styledComponents/Buttons.styles';
import { Loader } from '../../../styledComponents/Components.styles';
import { Tooltip } from '@mui/material';

function SubmitButton({ onClick, buttonText, isFormSaved, isLoading, isFailedSubmit, tooltipTitle = ''}) {

  const button = (
    <StyledSubmitButton
        className="save-btn"
        onClick={onClick}
        isDisabled={isFormSaved || isLoading || isFailedSubmit}
        isFailedSubmit={isFailedSubmit} >
      {isLoading ? <Loader className="loader" /> : buttonText}
    </StyledSubmitButton>
  );

  return (

      isFailedSubmit ? (

        <Tooltip title="Submit Failed. Refresh the page to try again.">
          <StyledSubmitButton 
            className="save-btn"
            onClick={onClick}
            isDisabled={isLoading} 
            isFailedSubmit={true}
            >
            {isLoading ? <Loader className="loader" /> : "Submit Failed"}
          </StyledSubmitButton>
        </Tooltip>
      ) : 
      tooltipTitle ? (
        <Tooltip title={tooltipTitle} describeChild>
          <span style={{display: 'inline-flex'}}>{button}</span>
        </Tooltip>
      ) : button
  );
}

export default SubmitButton;
